import React, { useState } from 'react'
import FileDropZone from './MediaUpload/FileDropZone'
import FileList from './MediaUpload/FileList'
import UploadButton from './MediaUpload/UploadButton'
import PhotoEditor from './PhotoEditor/PhotoEditor'
import { useFileUpload } from '../hooks/useFileUpload'
import { useDragAndDrop } from '../hooks/useDragAndDrop'

const MediaUpload = ({ eventId, onUploadSuccess, onError }) => {
  const {
    files,
    uploading,
    handleFiles,
    updateDescription,
    updateCustomName,
    removeFile,
    updateFilePreview,
    uploadFiles
  } = useFileUpload(eventId, onUploadSuccess, onError)

  const { dragActive, handleDrag, handleDrop } = useDragAndDrop(handleFiles)
  const [editingFileId, setEditingFileId] = useState(null)
  const [editingImage, setEditingImage] = useState(null)

  const handleEditPhoto = (fileId) => {
    const fileObj = files.find(f => f.id === fileId)
    if (fileObj && fileObj.preview) {
      setEditingFileId(fileId)
      setEditingImage(fileObj.preview)
    }
  }

  const handleSaveEdit = (editedImageData) => {
    if (editingFileId) {
      updateFilePreview(editingFileId, editedImageData)
    }
    setEditingFileId(null)
    setEditingImage(null)
  }

  const handleCancelEdit = () => {
    setEditingFileId(null)
    setEditingImage(null)
  }

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  return (
    <div className="space-y-4">
      <FileDropZone
        dragActive={dragActive}
        onDrag={handleDrag}
        onDrop={handleDrop}
        onFileSelect={handleFiles}
      />

      {files.length > 0 && (
        <>
          <FileList
            files={files}
            onUpdateDescription={updateDescription}
            onUpdateCustomName={updateCustomName}
            onRemoveFile={removeFile}
            onEditPhoto={handleEditPhoto}
            formatFileSize={formatFileSize}
          />

          <UploadButton
            files={files}
            uploading={uploading}
            onUpload={uploadFiles}
            eventId={eventId}
          />
        </>
      )}

      {editingFileId && editingImage && (
        <PhotoEditor
          image={editingImage}
          onSave={handleSaveEdit}
          onCancel={handleCancelEdit}
        />
      )}
    </div>
  )
}

export default MediaUpload